// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__hgc-Y","header":"ReportDetails_header__3ki9N","title":"ReportDetails_title__25HkY","left":"ReportDetails_left__1FBig"};